import React from 'react';
import styles from './UserInsights.module.scss';
import UserActivities from 'component/molecules/Dashboard/user-activities/UserActivities';
import { useBrandingContext } from 'app-context/BrandingsContext';
import DailyConversations from 'component/molecules/Dashboard/daily-conversations/DailyConversations';
import MessagesByTopic from 'component/molecules/Dashboard/messages-by-topic/MessagesByTopic';
import UserInsightsStatistics from 'component/molecules/Dashboard/user-insights-statistics/UserInsightsStatistics';

const UserInsights = ({
  botId,
  startDate,
  endDate,
  days,
  snapshotMode,
  isExporting,
  botType,
}) => {
  const { brandingData } = useBrandingContext();

  return (
    <div
      className={`${styles['user-insights-container']} ${
        snapshotMode ? styles['snapshot-mode'] : ''
      }`}
    >
      <div data-export='daily-conversations'>
        <DailyConversations
          brandingData={brandingData}
          botId={botId}
          startDate={startDate}
          endDate={endDate}
          days={days}
          snapshotMode={snapshotMode}
          isExporting={isExporting}
          botType={botType}
        />
      </div>
      <div data-export='messages-by-topic'>
        <MessagesByTopic
          brandingData={brandingData}
          id={botId}
          startDate={startDate}
          endDate={endDate}
          botType={botType}
        />
      </div>
      <div data-export='user-activities'>
        <UserActivities
          brandingData={brandingData}
          id={botId}
          startDate={startDate}
          endDate={endDate}
          botType={botType}
        />
      </div>
      <div data-export='user-insights-statistics'>
        <UserInsightsStatistics
          startDate={startDate}
          endDate={endDate}
          botId={botId}
          snapshotMode={snapshotMode}
          botType={botType}
        />
      </div>
    </div>
  );
};

export default UserInsights;
